import React, { Component } from 'react'

class LoginPage extends Component {
  render () {
    return (
      <div>
        <h1>Login</h1>
      </div>
    )
  }
}

export default LoginPage



// WEBPACK FOOTER //
// ./src/components/loginpage.js